export const buildVars = {
	"version": "3.1.0",
	"build": "16357",
	"angularVersion": "22.2.2",
	"nxVersion": "23.3.0",
	"commitId": "ed2fd8b50a",
	"commitTime": "2026-11-04 16:35:09 +0100",
	"branch": "CON-player-insight-unpublish"
};
